// extracted by mini-css-extract-plugin
module.exports = {"root":"ControlCardNotes_root__2GS5N","boldText":"ControlCardNotes_boldText__2dT9L","paddingRight":"ControlCardNotes_paddingRight__vsovD"};